import { render, staticRenderFns } from "./repeat-pickure-table.vue?vue&type=template&id=4befa95c&scoped=true&"
import script from "./repeat-pickure-table.vue?vue&type=script&lang=js&"
export * from "./repeat-pickure-table.vue?vue&type=script&lang=js&"
import style0 from "./repeat-pickure-table.vue?vue&type=style&index=0&id=4befa95c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befa95c",
  null
  
)

export default component.exports